import {
  Cell,
  Legend,
  Pie,
  PieChart,
  ResponsiveContainer,
  Tooltip,
} from "recharts";

const COLORS = [
  "#2563eb",
  "#16a34a",
  "#dc2626",
  "#7c3aed",
  "#ea580c",
  "#0891b2",
  "#ca8a04",
  "#4f46e5",
  "#0d9488",
  "#be123c",
];

const CountryView = ({ countries }) => {
  const data = (countries || [])
    .map((item) => ({
      name:
        item.country_name ||
        (item.country_id ? `Country ${item.country_id}` : "Unknown"),
      value: item.total_sales_amount_in_target_currency ?? 0,
    }))
    .sort((a, b) => b.value - a.value);
  const chartData = data.slice(0, 10);

  return (
    <div className="card">
      <h5>Top Countries</h5>
      <div className="mt-4">
        {data.length === 0 ? (
          <div className="opacity-70 text-sm">No country data.</div>
        ) : (
          <ResponsiveContainer width="100%" height={320}>
            <PieChart>
              <Pie
                data={chartData}
                dataKey="value"
                nameKey="name"
                cx="50%"
                cy="50%"
                outerRadius={110}
                label={({ percent }) => `${(percent * 100).toFixed(1)}%`}
              >
                {chartData.map((entry, index) => (
                  <Cell
                    key={`cell-${entry.name}`}
                    fill={COLORS[index % COLORS.length]}
                  />
                ))}
              </Pie>
              <Tooltip formatter={(value) => Number(value).toLocaleString()} />
              <Legend />
            </PieChart>
          </ResponsiveContainer>
        )}
      </div>
    </div>
  );
};

export default CountryView;
